{
  "schema": "ft.inventory-identity-aliases.v1",
  "aliases": {
    "E4C0261B-4150-4682-AD28-06C25063FE6A": {
      "canonical": "32C76F4B-80B2-EECE-DC8F-ED8F7DEE76E2",
      "type": "equipment",
      "default_mesh_id": "419B3762-9553-F9DD-2DB0-CD036465F8FC"
    },
    "F1971722-30A3-17BA-3634-D1796A597C17": {
      "canonical": "32C76F4B-80B2-EECE-DC8F-ED8F7DEE76E2",
      "type": "equipment",
      "default_mesh_id": null
    },
    "CE6E8804-EB34-4A8A-9F74-AAB5DA09A736": {
      "canonical": "32C76F4B-80B2-EECE-DC8F-ED8F7DEE76E2",
      "type": "equipment",
      "default_mesh_id": null
    },
    "DA8A65FF-9904-4EA7-AE83-78C375664705": {
      "canonical": "FDED8F15-48AE-4D3C-B5E2-D531F9996C64",
      "type": "furniture",
      "default_mesh_id": null
    },
    "C2DE414C-B3F0-4D06-A376-724FAE1CA522": {
      "canonical": "FDED8F15-48AE-4D3C-B5E2-D531F9996C64",
      "type": "furniture",
      "default_mesh_id": null
    },
    "32B1241C-C49A-754D-188F-3803E596B5ED": {
      "canonical": "7FB75162-DB32-5BCC-1B26-6EA56E201228",
      "type": "container",
      "default_mesh_id": null
    },
    "8406D102-60F1-9ECE-E23A-19EDA6F8010C": {
      "canonical": "7FB75162-DB32-5BCC-1B26-6EA56E201228",
      "type": "container",
      "default_mesh_id": null
    },
    "BE4C3E93-F586-DAFC-A5D5-13EDD5E272DD": {
      "canonical": "7FB75162-DB32-5BCC-1B26-6EA56E201228",
      "type": "container",
      "default_mesh_id": null
    },
    "20B6C83D-B027-5ADD-F282-CBAF5E6E765C": {
      "canonical": "7FB75162-DB32-5BCC-1B26-6EA56E201228",
      "type": "container",
      "default_mesh_id": null
    },
    "AFB4B1B8-815D-4F41-7F5C-7F19FF6EE425": {
      "canonical": "7FB75162-DB32-5BCC-1B26-6EA56E201228",
      "type": "container",
      "default_mesh_id": null
    },
    "79354630-AFA1-AB2E-5F61-5F709B3A5707": {
      "canonical": "7FB75162-DB32-5BCC-1B26-6EA56E201228",
      "type": "container",
      "default_mesh_id": null
    },
    "1ECB591D-7248-715C-8BB1-686ED5E5908D": {
      "canonical": "7FB75162-DB32-5BCC-1B26-6EA56E201228",
      "type": "container",
      "default_mesh_id": null
    },
    "E6ED0400-05F5-4FA7-93F9-DA832272A26D": {
      "canonical": "8FC1697F-B622-4B74-2F4F-1E8567D35DCB",
      "type": "artwork",
      "default_mesh_id": null
    },
    "053DB58A-E5D7-00D6-5B74-D1F7696C55EC": {
      "canonical": "8FC1697F-B622-4B74-2F4F-1E8567D35DCB",
      "type": "artwork",
      "default_mesh_id": null
    },
    "14CAC667-731A-1C30-CB92-E3A422B7C068": {
      "canonical": "8FC1697F-B622-4B74-2F4F-1E8567D35DCB",
      "type": "artwork",
      "default_mesh_id": null
    },
    "D0D095B1-FFB0-2EB3-0E65-C98AA1C2019C": {
      "canonical": "0D8B8143-B65C-BE72-9C0B-7FCF76E528EB",
      "type": "building",
      "default_mesh_id": null
    },
    "96072A7A-CE0A-1177-1D93-628C595A261E": {
      "canonical": "0D8B8143-B65C-BE72-9C0B-7FCF76E528EB",
      "type": "building",
      "default_mesh_id": null
    },
    "80B9966F-0CC1-C276-32A2-20488520DB4D": {
      "canonical": "0D8B8143-B65C-BE72-9C0B-7FCF76E528EB",
      "type": "building",
      "default_mesh_id": null
    },
    "68580875-AD9F-CA7C-1854-EB8526F5CAA3": {
      "canonical": "0D8B8143-B65C-BE72-9C0B-7FCF76E528EB",
      "type": "building",
      "default_mesh_id": null
    },
    "B94A0FEB-1EEC-9D78-46A0-5C86B4316FEC": {
      "canonical": "0D8B8143-B65C-BE72-9C0B-7FCF76E528EB",
      "type": "building",
      "default_mesh_id": null
    },
    "789E59D3-14B9-5EFC-4EF5-E65E9E9AF595": {
      "canonical": "0D8B8143-B65C-BE72-9C0B-7FCF76E528EB",
      "type": "building",
      "default_mesh_id": "E54AC0B6-0EC7-CBAA-A878-129DB4FDFC30"
    },
    "DFFF33F5-7795-5AFE-98EF-4CEBB59997B2": {
      "canonical": "0D8B8143-B65C-BE72-9C0B-7FCF76E528EB",
      "type": "building",
      "default_mesh_id": "52297934-F9ED-E7A6-595F-122CFC9A36CA"
    },
    "2D36BFE3-14A5-11AF-BADD-72612ED1911A": {
      "canonical": "24977B90-0883-F2D0-0DD6-7B10CF512E08",
      "type": "container",
      "default_mesh_id": "0A97928B-8F5F-0230-1C24-58934C5D1B8A"
    },
    "15833B09-C4E7-0D50-9214-B2E01A9FF01C": {
      "canonical": "24977B90-0883-F2D0-0DD6-7B10CF512E08",
      "type": "container",
      "default_mesh_id": null
    },
    "D48F1D47-FBC7-68E5-C568-7F35441404FA": {
      "canonical": "24977B90-0883-F2D0-0DD6-7B10CF512E08",
      "type": "container",
      "default_mesh_id": null
    },
    "5B914E02-7A29-5B12-2D36-CBE6060A3023": {
      "canonical": "24977B90-0883-F2D0-0DD6-7B10CF512E08",
      "type": "container",
      "default_mesh_id": null
    },
    "01EF5BB0-A76C-B24C-B14E-D125ADB572BC": {
      "canonical": "24977B90-0883-F2D0-0DD6-7B10CF512E08",
      "type": "container",
      "default_mesh_id": null
    },
    "45DC5EA6-33C9-9BC5-8EDC-10BC368B0BC2": {
      "canonical": "24977B90-0883-F2D0-0DD6-7B10CF512E08",
      "type": "container",
      "default_mesh_id": null
    },
    "349D2021-69EA-758B-877E-F91206397D12": {
      "canonical": "24977B90-0883-F2D0-0DD6-7B10CF512E08",
      "type": "container",
      "default_mesh_id": null
    },
    "4BDF9D48-32EE-EFF1-26BA-BDD81A3D64C2": {
      "canonical": "E47A23B0-5918-A56B-A56B-E3FEBF622616",
      "type": "furniture",
      "default_mesh_id": "11F1D630-3065-2B88-8156-F2B440F4DC22"
    },
    "3FFD36A5-43FB-E890-30A5-94E61B324F4B": {
      "canonical": "E47A23B0-5918-A56B-A56B-E3FEBF622616",
      "type": "furniture",
      "default_mesh_id": null
    },
    "44B77A23-1238-4C7D-94B9-9865195E852E": {
      "canonical": "A643531C-667C-531A-9420-B620B3321FEB",
      "type": "building",
      "default_mesh_id": null
    },
    "B5417F3E-1BEF-4FD4-A814-91D10F2FEAA5": {
      "canonical": "A643531C-667C-531A-9420-B620B3321FEB",
      "type": "building",
      "default_mesh_id": null
    },
    "8F76CF9F-FB08-4462-8271-D092B5233AB5": {
      "canonical": "A643531C-667C-531A-9420-B620B3321FEB",
      "type": "building",
      "default_mesh_id": null
    },
    "A236A135-FA93-430B-9DF1-02B728EBC628": {
      "canonical": "A643531C-667C-531A-9420-B620B3321FEB",
      "type": "building",
      "default_mesh_id": null
    },
    "916903CD-3B68-E4C0-9556-0AC331571B8A": {
      "canonical": "A643531C-667C-531A-9420-B620B3321FEB",
      "type": "building",
      "default_mesh_id": null
    },
    "4D8966CD-4D3D-5725-3412-8C13903FB7AB": {
      "canonical": "A643531C-667C-531A-9420-B620B3321FEB",
      "type": "building",
      "default_mesh_id": "E16BE8A0-0BA1-6370-7D80-37E92BEB78AD"
    },
    "475636AA-C11C-EA9F-95C7-325C2AD6952B": {
      "canonical": "A643531C-667C-531A-9420-B620B3321FEB",
      "type": "building",
      "default_mesh_id": null
    },
    "F0D49F10-9C69-4158-9614-C34211F64C9D": {
      "canonical": "CC39B2BC-3C73-48F8-8CF2-B091BD65E6D6",
      "type": "furniture",
      "default_mesh_id": "C6218626-D65D-B334-BA23-FAD321596BDB"
    },
    "3316D459-A995-402A-A645-417188EFCD36": {
      "canonical": "BACAD59F-F34E-D074-62F2-0B35CC8EF6FD",
      "type": "furniture",
      "default_mesh_id": null
    },
    "40699859-460C-8ED1-2A1E-21FF8AFD81F5": {
      "canonical": "BACAD59F-F34E-D074-62F2-0B35CC8EF6FD",
      "type": "furniture",
      "default_mesh_id": null
    },
    "9A627E81-8BB5-26B2-3181-803C892C8B0E": {
      "canonical": "ABE07D2F-7E8D-E61E-BCEE-AD1C2435C9D8",
      "type": "furniture",
      "default_mesh_id": "2BB85A61-6B04-C70C-9EE7-FC3C01F2BA59"
    },
    "F3C4CBBB-E080-2301-314C-8F8AB68FCFB3": {
      "canonical": "3C00F6E0-BFE8-439F-AE1F-544CEB506AEE",
      "type": "door",
      "default_mesh_id": null
    },
    "89E27870-A9F1-A220-02C5-BAFD2B235778": {
      "canonical": "10D52DEE-EB82-79C6-0F8C-BCFC76B11C00",
      "type": "trap",
      "default_mesh_id": null
    },
    "E44C6B8E-8A7D-7419-C0BB-9D884B463C97": {
      "canonical": "10D52DEE-EB82-79C6-0F8C-BCFC76B11C00",
      "type": "trap",
      "default_mesh_id": null
    },
    "6997FF40-7529-D174-6DFD-92C8B98FACAD": {
      "canonical": "10D52DEE-EB82-79C6-0F8C-BCFC76B11C00",
      "type": "trap",
      "default_mesh_id": null
    },
    "41E03A45-C6AD-5318-8977-994AE8050B82": {
      "canonical": "610CA094-4DFC-4B67-1700-E91DB486B65E",
      "type": "furniture",
      "default_mesh_id": "8EA7257D-CD1A-BFD0-1EED-96B399C9E208"
    },
    "E6703934-A26F-7FEF-CE8A-F1D1D6C3412F": {
      "canonical": "610CA094-4DFC-4B67-1700-E91DB486B65E",
      "type": "furniture",
      "default_mesh_id": "83F66921-0159-7F96-BFC9-A8A9AC4E0A7A"
    },
    "B332C50A-D217-10FE-0A2B-5752C3631D3B": {
      "canonical": "8F81AC25-8436-480F-2C46-F2239C424D22",
      "type": "furniture",
      "default_mesh_id": null
    },
    "4695E03B-7E14-E22F-CA45-83C56A0D8704": {
      "canonical": "8F81AC25-8436-480F-2C46-F2239C424D22",
      "type": "furniture",
      "default_mesh_id": null
    },
    "E35D758D-56A3-0C25-F197-6A1B54137BE6": {
      "canonical": "8F81AC25-8436-480F-2C46-F2239C424D22",
      "type": "furniture",
      "default_mesh_id": "11A382A1-E17C-2FEB-8832-4D2EBBAE9177"
    },
    "D6562E90-822F-E981-E445-D230CCFA21CD": {
      "canonical": "14D54E8A-71A8-3D1E-6F0A-0171A627DF31",
      "type": "equipment",
      "default_mesh_id": null
    },
    "C8F57E32-282A-00CC-A861-19AC48E02AE2": {
      "canonical": "363A94AF-0EB9-BAD5-CE02-74335A72DA9A",
      "type": "building",
      "default_mesh_id": null
    },
    "B17D7676-8435-45DC-2828-D04E27732446": {
      "canonical": "363A94AF-0EB9-BAD5-CE02-74335A72DA9A",
      "type": "building",
      "default_mesh_id": null
    },
    "D1781E1F-2834-CFF7-A451-B20FBB74BE1C": {
      "canonical": "56369E28-E5D9-38E5-4D44-EFB68F00A698",
      "type": "furniture",
      "default_mesh_id": null
    },
    "44D30E26-68EF-C3A2-279F-EBC34BB0127B": {
      "canonical": "56369E28-E5D9-38E5-4D44-EFB68F00A698",
      "type": "furniture",
      "default_mesh_id": null
    },
    "A36FB63C-7134-43DA-BE7C-2B2299C54285": {
      "canonical": "56369E28-E5D9-38E5-4D44-EFB68F00A698",
      "type": "furniture",
      "default_mesh_id": "101192BE-A72A-AAAF-7E80-552DAC5A93CA"
    },
    "D3FCDF86-D59C-715C-7065-11AE60C277A7": {
      "canonical": "A0362F8C-BE45-8B3A-4E31-8D0FBBEE624C",
      "type": "equipment",
      "default_mesh_id": null
    },
    "3AF6FE5C-FBCA-8C3C-D296-2581D119494E": {
      "canonical": "A0362F8C-BE45-8B3A-4E31-8D0FBBEE624C",
      "type": "equipment",
      "default_mesh_id": null
    },
    "3B8E88F8-E1D6-E3E1-ACB4-6310C59B58C6": {
      "canonical": "447544BA-1E1B-FD5E-2DC7-5AC381FFD56F",
      "type": "container",
      "default_mesh_id": null
    },
    "B1998AFE-8F5E-97BB-A2B2-2010BE1AEEAD": {
      "canonical": "034D93C9-4C92-850D-EE51-23A6CBB79B8D",
      "type": "building",
      "default_mesh_id": null
    },
    "FA0ED1E8-2B68-125D-307D-6FC2692502A0": {
      "canonical": "034D93C9-4C92-850D-EE51-23A6CBB79B8D",
      "type": "building",
      "default_mesh_id": null
    },
    "94B91BBB-CA3D-85EE-5DD2-3CE9AACFB04C": {
      "canonical": "034D93C9-4C92-850D-EE51-23A6CBB79B8D",
      "type": "building",
      "default_mesh_id": null
    },
    "A2A6639E-55A2-E420-B67C-B1881E65D328": {
      "canonical": "034D93C9-4C92-850D-EE51-23A6CBB79B8D",
      "type": "building",
      "default_mesh_id": null
    },
    "ADEE6240-02B8-499E-8400-2C30DFC8C170": {
      "canonical": "034D93C9-4C92-850D-EE51-23A6CBB79B8D",
      "type": "building",
      "default_mesh_id": null
    },
    "93EA27DC-B908-376B-83E7-7B441534570C": {
      "canonical": "86548D6C-A916-F3FE-DC4D-67064A760A13",
      "type": "building",
      "default_mesh_id": null
    },
    "E3D38CAA-124A-E3B7-3101-C62C8553FAB9": {
      "canonical": "86548D6C-A916-F3FE-DC4D-67064A760A13",
      "type": "building",
      "default_mesh_id": null
    },
    "B1B8FF12-B3FA-E249-EAF8-F9FF15FA6DAC": {
      "canonical": "86548D6C-A916-F3FE-DC4D-67064A760A13",
      "type": "building",
      "default_mesh_id": null
    },
    "D4376C05-9130-1549-3773-96B10D0705CB": {
      "canonical": "86548D6C-A916-F3FE-DC4D-67064A760A13",
      "type": "building",
      "default_mesh_id": null
    },
    "039DDB09-1C7F-46F5-2D27-BAC1CB73F902": {
      "canonical": "86548D6C-A916-F3FE-DC4D-67064A760A13",
      "type": "building",
      "default_mesh_id": null
    },
    "1C4695C1-A5EB-E40A-04B5-91E3CE2105E8": {
      "canonical": "86548D6C-A916-F3FE-DC4D-67064A760A13",
      "type": "building",
      "default_mesh_id": null
    },
    "6E5F4585-5E85-87E7-77F7-BBB4CA3D0804": {
      "canonical": "86548D6C-A916-F3FE-DC4D-67064A760A13",
      "type": "building",
      "default_mesh_id": null
    },
    "00A75641-71FC-D4DE-4A3E-4FDBED6AE1A4": {
      "canonical": "3F1012A9-8534-CA30-6063-9873A1B19340",
      "type": "furniture",
      "default_mesh_id": null
    },
    "7CBE8E7B-F677-1972-2D1D-3F49D49401A9": {
      "canonical": "FEAB7312-FD22-A469-B482-CB691994E7E9",
      "type": "building",
      "default_mesh_id": null
    },
    "77FB8B28-3F9F-7796-F7A2-268D421B0A81": {
      "canonical": "FEAB7312-FD22-A469-B482-CB691994E7E9",
      "type": "building",
      "default_mesh_id": "0BBECFC7-8FFE-E141-CF9D-BEC11F1C4164"
    },
    "B9C7D3AD-5BA5-63FB-1635-59273AEBAF23": {
      "canonical": "FEAB7312-FD22-A469-B482-CB691994E7E9",
      "type": "building",
      "default_mesh_id": null
    },
    "970831A6-CE4D-1FAF-41F0-30EFA9905F14": {
      "canonical": "FEAB7312-FD22-A469-B482-CB691994E7E9",
      "type": "building",
      "default_mesh_id": null
    },
    "4F9644C5-1E34-4B97-E652-D7A321E47326": {
      "canonical": "FEAB7312-FD22-A469-B482-CB691994E7E9",
      "type": "building",
      "default_mesh_id": null
    },
    "B216F711-F2FC-59FD-9021-25407D65B797": {
      "canonical": "FEAB7312-FD22-A469-B482-CB691994E7E9",
      "type": "building",
      "default_mesh_id": null
    },
    "D738FEAC-B102-07CF-C2AC-8E19EDBDD025": {
      "canonical": "FEAB7312-FD22-A469-B482-CB691994E7E9",
      "type": "building",
      "default_mesh_id": null
    },
    "06A3F450-AEB9-6319-4928-D1CEDF0E1B9E": {
      "canonical": "D2ACDCCE-C0EA-C9AC-68A2-FA693B775DB6",
      "type": "building",
      "default_mesh_id": null
    },
    "90FE2360-1A1A-A46A-B6D1-2AB912D6B6EA": {
      "canonical": "D2ACDCCE-C0EA-C9AC-68A2-FA693B775DB6",
      "type": "building",
      "default_mesh_id": null
    },
    "8818C331-C9DA-F4F3-2D43-07344F510D60": {
      "canonical": "D2ACDCCE-C0EA-C9AC-68A2-FA693B775DB6",
      "type": "building",
      "default_mesh_id": null
    },
    "F81070DB-C095-084C-58F8-F4586F71B2AD": {
      "canonical": "D2ACDCCE-C0EA-C9AC-68A2-FA693B775DB6",
      "type": "building",
      "default_mesh_id": null
    },
    "A386CA11-3CB8-1A05-9F17-F5BE509C15F4": {
      "canonical": "D2ACDCCE-C0EA-C9AC-68A2-FA693B775DB6",
      "type": "building",
      "default_mesh_id": null
    },
    "262D97FD-B038-FE47-6ABD-C6BF3976C0CD": {
      "canonical": "D2ACDCCE-C0EA-C9AC-68A2-FA693B775DB6",
      "type": "building",
      "default_mesh_id": null
    },
    "C45B3FC0-5287-4BDF-5E29-3BCD7BEC68A2": {
      "canonical": "D2ACDCCE-C0EA-C9AC-68A2-FA693B775DB6",
      "type": "building",
      "default_mesh_id": null
    },
    "6DE24F07-96F2-E24F-0E64-EBBF05A007E8": {
      "canonical": "CCB85C01-E75C-6C28-3914-30469815F5C2",
      "type": "building",
      "default_mesh_id": null
    },
    "5F6F87CA-172A-E5D5-3511-212E357B3F13": {
      "canonical": "CCB85C01-E75C-6C28-3914-30469815F5C2",
      "type": "building",
      "default_mesh_id": null
    },
    "796FBB5D-265B-6BBB-8747-ED03D9B7AFBE": {
      "canonical": "95D030E2-F48C-B7E7-9B00-25CA012E8A22",
      "type": "building",
      "default_mesh_id": null
    },
    "A4894DB0-7A7C-7C0D-2E4B-29D990689CCA": {
      "canonical": "95D030E2-F48C-B7E7-9B00-25CA012E8A22",
      "type": "building",
      "default_mesh_id": null
    },
    "4E480139-D0BA-F5C2-521C-E93B08E0F74F": {
      "canonical": "95D030E2-F48C-B7E7-9B00-25CA012E8A22",
      "type": "building",
      "default_mesh_id": null
    },
    "70EA56ED-516F-B11C-E322-7B33D34F3BA3": {
      "canonical": "95D030E2-F48C-B7E7-9B00-25CA012E8A22",
      "type": "building",
      "default_mesh_id": null
    },
    "CC026911-190F-7C6E-28F7-A5B23AD08E24": {
      "canonical": "95D030E2-F48C-B7E7-9B00-25CA012E8A22",
      "type": "building",
      "default_mesh_id": null
    },
    "7B5D7D95-1CB5-714D-C2FB-B78AF56E8349": {
      "canonical": "95D030E2-F48C-B7E7-9B00-25CA012E8A22",
      "type": "building",
      "default_mesh_id": null
    },
    "AE8E7D5A-8537-D24A-373C-6244685EB45F": {
      "canonical": "95D030E2-F48C-B7E7-9B00-25CA012E8A22",
      "type": "building",
      "default_mesh_id": null
    },
    "CADFCE72-EF7B-2E25-3EA3-8DF2891798AA": {
      "canonical": "196C1E04-1323-C1C9-3340-93118D6BF69F",
      "type": "building",
      "default_mesh_id": null
    },
    "45331525-636D-0C69-7927-BB289FD3E50B": {
      "canonical": "196C1E04-1323-C1C9-3340-93118D6BF69F",
      "type": "building",
      "default_mesh_id": null
    },
    "2A36693A-4F71-8B93-3284-83BCE01D82CE": {
      "canonical": "196C1E04-1323-C1C9-3340-93118D6BF69F",
      "type": "building",
      "default_mesh_id": null
    },
    "066D08D0-98F0-C89F-6432-EB987B50F6CB": {
      "canonical": "196C1E04-1323-C1C9-3340-93118D6BF69F",
      "type": "building",
      "default_mesh_id": null
    },
    "B22E1F30-66C0-912A-18EB-3FD74D8E7EB1": {
      "canonical": "196C1E04-1323-C1C9-3340-93118D6BF69F",
      "type": "building",
      "default_mesh_id": null
    },
    "9A8D9AE0-C545-AC22-45CE-89CF893A17E0": {
      "canonical": "196C1E04-1323-C1C9-3340-93118D6BF69F",
      "type": "building",
      "default_mesh_id": null
    },
    "A1892801-7B87-7A69-9202-E0BF77A4CD48": {
      "canonical": "196C1E04-1323-C1C9-3340-93118D6BF69F",
      "type": "building",
      "default_mesh_id": null
    },
    "0BA64715-69E5-C9C5-F458-CADB6B14C6BE": {
      "canonical": "9E03CA88-9B2E-5727-1EC2-99C94E610EFB",
      "type": "building",
      "default_mesh_id": null
    },
    "B868CECC-13AC-464B-BD64-72F3DA9D44E7": {
      "canonical": "9E03CA88-9B2E-5727-1EC2-99C94E610EFB",
      "type": "building",
      "default_mesh_id": null
    },
    "63BFCF1D-7AB4-013B-F6B1-E074DB5BECDF": {
      "canonical": "9E03CA88-9B2E-5727-1EC2-99C94E610EFB",
      "type": "building",
      "default_mesh_id": null
    },
    "70B600A3-C75E-64F7-7C05-A882B7607F38": {
      "canonical": "9E03CA88-9B2E-5727-1EC2-99C94E610EFB",
      "type": "building",
      "default_mesh_id": null
    },
    "5196A90E-E677-2835-13D1-CF3193BFAA83": {
      "canonical": "9E03CA88-9B2E-5727-1EC2-99C94E610EFB",
      "type": "building",
      "default_mesh_id": null
    },
    "87ABE069-A1BC-31B6-8020-2D1B757FF4D2": {
      "canonical": "9E03CA88-9B2E-5727-1EC2-99C94E610EFB",
      "type": "building",
      "default_mesh_id": null
    },
    "155E2FF6-4B3C-7996-E7FA-5394E2079B60": {
      "canonical": "9E03CA88-9B2E-5727-1EC2-99C94E610EFB",
      "type": "building",
      "default_mesh_id": null
    },
    "4B928DFF-838F-7F9F-A3D6-976196294676": {
      "canonical": "CB8D4628-7FE2-5D5C-5433-308F757808D9",
      "type": "trap",
      "default_mesh_id": null
    },
    "71BB39FF-5089-13F1-A847-F612827B186A": {
      "canonical": "CB8D4628-7FE2-5D5C-5433-308F757808D9",
      "type": "trap",
      "default_mesh_id": null
    },
    "10E555CD-E2B1-F04E-311A-008515D56FD1": {
      "canonical": "CB8D4628-7FE2-5D5C-5433-308F757808D9",
      "type": "trap",
      "default_mesh_id": null
    },
    "C8200387-050D-42F1-A9E9-01D96A68B90D": {
      "canonical": "E3EB2695-0A4E-BEE6-C4C1-EE6231C07FB8",
      "type": "furniture",
      "default_mesh_id": "2F26E852-AEB4-A6EF-EF7E-FAF0BAF246D2"
    },
    "90D5444D-C295-17DA-1D2F-79C818A05FC6": {
      "canonical": "55C4278F-5DBA-67FA-7C0C-5A5C9B9272D6",
      "type": "building",
      "default_mesh_id": null
    },
    "9443BCC9-014E-197E-6B22-94FF06813FEA": {
      "canonical": "55C4278F-5DBA-67FA-7C0C-5A5C9B9272D6",
      "type": "building",
      "default_mesh_id": null
    },
    "735F8233-4D63-42E5-5CEC-7EC41D58D7DD": {
      "canonical": "55C4278F-5DBA-67FA-7C0C-5A5C9B9272D6",
      "type": "building",
      "default_mesh_id": null
    },
    "1835ED5E-3DD4-2FE3-1018-9FAA5DBAE427": {
      "canonical": "55C4278F-5DBA-67FA-7C0C-5A5C9B9272D6",
      "type": "building",
      "default_mesh_id": null
    },
    "7A575D02-5F20-A0AE-0EBB-719EB17FDDA9": {
      "canonical": "55C4278F-5DBA-67FA-7C0C-5A5C9B9272D6",
      "type": "building",
      "default_mesh_id": null
    },
    "D668EFF0-B349-020E-C58A-56CFB20E1443": {
      "canonical": "55C4278F-5DBA-67FA-7C0C-5A5C9B9272D6",
      "type": "building",
      "default_mesh_id": null
    },
    "60F8D5EB-470A-5F6A-67BD-F0030DC922A5": {
      "canonical": "55C4278F-5DBA-67FA-7C0C-5A5C9B9272D6",
      "type": "building",
      "default_mesh_id": null
    },
    "BD5E264B-E2EB-091F-1369-4D683C42F9AE": {
      "canonical": "32ACB1DA-7335-08B1-9B65-05874D351072",
      "type": "equipment",
      "default_mesh_id": null
    },
    "58AB82B7-0EB9-1AD7-7D4D-458F3757E9DD": {
      "canonical": "86C31E94-809A-FD22-CFD0-C4E0ADFFB784",
      "type": "artwork",
      "default_mesh_id": null
    },
    "3C483890-2650-4546-B089-6372A494CF63": {
      "canonical": "86C31E94-809A-FD22-CFD0-C4E0ADFFB784",
      "type": "artwork",
      "default_mesh_id": null
    },
    "AC3772BC-4FF4-C373-252D-7ACB227CEE58": {
      "canonical": "86C31E94-809A-FD22-CFD0-C4E0ADFFB784",
      "type": "artwork",
      "default_mesh_id": null
    },
    "922B4148-080F-1D0E-19D5-B5B09D122F0E": {
      "canonical": "CF5323D7-B794-9C9D-28D5-EDC6F932C47D",
      "type": "building",
      "default_mesh_id": null
    },
    "03765C18-B508-3349-20CF-59AA11CE0430": {
      "canonical": "CF5323D7-B794-9C9D-28D5-EDC6F932C47D",
      "type": "building",
      "default_mesh_id": null
    },
    "7AC458A9-86A0-8F4F-DACD-DD9B95703DAC": {
      "canonical": "CF5323D7-B794-9C9D-28D5-EDC6F932C47D",
      "type": "building",
      "default_mesh_id": null
    },
    "FA19FABF-03ED-4618-0D46-D603946ADC97": {
      "canonical": "CF5323D7-B794-9C9D-28D5-EDC6F932C47D",
      "type": "building",
      "default_mesh_id": null
    },
    "DD23C154-9F21-3C1A-4070-DFCC197D7632": {
      "canonical": "CF5323D7-B794-9C9D-28D5-EDC6F932C47D",
      "type": "building",
      "default_mesh_id": null
    },
    "5E6BD5AE-6EB2-22CF-F85D-C2AF580B8E5C": {
      "canonical": "CF5323D7-B794-9C9D-28D5-EDC6F932C47D",
      "type": "building",
      "default_mesh_id": null
    },
    "8E4299C2-F280-DD91-F3B1-94D2D981BEAE": {
      "canonical": "CF5323D7-B794-9C9D-28D5-EDC6F932C47D",
      "type": "building",
      "default_mesh_id": null
    },
    "9E279447-B4CC-A4AF-0747-C735A26402E9": {
      "canonical": "F58C41EE-3281-EC65-EA8C-841C75DAE1CF",
      "type": "building",
      "default_mesh_id": null
    },
    "7FA3E031-4D7E-1080-3106-08800A6DEFDF": {
      "canonical": "D2AA1578-AFF3-DA07-933A-51BB74F38509",
      "type": "building",
      "default_mesh_id": null
    },
    "45740C92-8ED1-3EEC-A833-9FD3F80A4475": {
      "canonical": "D2AA1578-AFF3-DA07-933A-51BB74F38509",
      "type": "building",
      "default_mesh_id": null
    },
    "D439A6F6-14DD-21C8-5B9D-D958E39DB79B": {
      "canonical": "D2AA1578-AFF3-DA07-933A-51BB74F38509",
      "type": "building",
      "default_mesh_id": null
    },
    "CB827302-9953-D72F-6BDD-0D5111E79FE2": {
      "canonical": "D2AA1578-AFF3-DA07-933A-51BB74F38509",
      "type": "building",
      "default_mesh_id": null
    },
    "4CB31D9F-38E1-2C76-DD4F-E169FFACA1E8": {
      "canonical": "D2AA1578-AFF3-DA07-933A-51BB74F38509",
      "type": "building",
      "default_mesh_id": null
    },
    "36ACBE44-D7A9-2E12-7B89-3ADFF1360838": {
      "canonical": "D2AA1578-AFF3-DA07-933A-51BB74F38509",
      "type": "building",
      "default_mesh_id": null
    },
    "80A5279C-4764-CC2D-3676-729634742F6D": {
      "canonical": "D2AA1578-AFF3-DA07-933A-51BB74F38509",
      "type": "building",
      "default_mesh_id": null
    },
    "7A3057B3-3F57-8E93-7EC1-15C97D2D1368": {
      "canonical": "8EFFB04B-91F1-AD56-EF3C-754EFA29F8AA",
      "type": "building",
      "default_mesh_id": null
    },
    "4190F5E8-DB2E-FDE8-EED0-345163D10B20": {
      "canonical": "8EFFB04B-91F1-AD56-EF3C-754EFA29F8AA",
      "type": "building",
      "default_mesh_id": null
    },
    "AE557265-C61A-4D62-E582-D36E8CD7C468": {
      "canonical": "8EFFB04B-91F1-AD56-EF3C-754EFA29F8AA",
      "type": "building",
      "default_mesh_id": null
    },
    "95DDF699-42A3-FA26-4F51-1428C000174E": {
      "canonical": "8EFFB04B-91F1-AD56-EF3C-754EFA29F8AA",
      "type": "building",
      "default_mesh_id": null
    },
    "144D10B9-7FDE-78F5-B5F1-4AC1EA092A6D": {
      "canonical": "8EFFB04B-91F1-AD56-EF3C-754EFA29F8AA",
      "type": "building",
      "default_mesh_id": null
    },
    "46CD60F6-BE1E-F907-F218-97D8E703BD0C": {
      "canonical": "8EFFB04B-91F1-AD56-EF3C-754EFA29F8AA",
      "type": "building",
      "default_mesh_id": null
    },
    "E745ADBF-6028-6A2C-7764-E112FAC1AF05": {
      "canonical": "8EFFB04B-91F1-AD56-EF3C-754EFA29F8AA",
      "type": "building",
      "default_mesh_id": null
    },
    "04D2DF14-59B2-AC5E-5C40-EACB440FE4C9": {
      "canonical": "6001FF50-A0CA-293B-9FAD-F28734C31D4C",
      "type": "building",
      "default_mesh_id": null
    },
    "AB4544ED-3F78-200C-CAE4-60BECD88CCF5": {
      "canonical": "6001FF50-A0CA-293B-9FAD-F28734C31D4C",
      "type": "building",
      "default_mesh_id": null
    },
    "383614A9-290F-B044-5219-3DE48BE52763": {
      "canonical": "6001FF50-A0CA-293B-9FAD-F28734C31D4C",
      "type": "building",
      "default_mesh_id": null
    },
    "B2E6B858-F77E-39A4-C062-E7262BAF8CB4": {
      "canonical": "6001FF50-A0CA-293B-9FAD-F28734C31D4C",
      "type": "building",
      "default_mesh_id": null
    },
    "39D9563C-EB2A-9497-07AC-E1CCBF1CD287": {
      "canonical": "6001FF50-A0CA-293B-9FAD-F28734C31D4C",
      "type": "building",
      "default_mesh_id": null
    },
    "4890E044-9EDD-72E4-941F-E4C6D1AAB491": {
      "canonical": "6001FF50-A0CA-293B-9FAD-F28734C31D4C",
      "type": "building",
      "default_mesh_id": null
    },
    "99CEBCAD-89D4-520F-4BE4-62D146CF93AE": {
      "canonical": "6001FF50-A0CA-293B-9FAD-F28734C31D4C",
      "type": "building",
      "default_mesh_id": null
    },
    "7E87ACB3-6810-4C4D-7013-B4AD4BCD7B7D": {
      "canonical": "48F29F8A-C5AE-A2F7-DD48-0CE3D8C710D1",
      "type": "building",
      "default_mesh_id": null
    },
    "C98B9109-B72A-A2C3-B732-50D6509B2A41": {
      "canonical": "48F29F8A-C5AE-A2F7-DD48-0CE3D8C710D1",
      "type": "building",
      "default_mesh_id": null
    },
    "C022BA84-D86F-4ABC-2749-0C6F24F32FF9": {
      "canonical": "48F29F8A-C5AE-A2F7-DD48-0CE3D8C710D1",
      "type": "building",
      "default_mesh_id": null
    },
    "E80D719F-CE49-5EDE-781F-0D8097119D7F": {
      "canonical": "48F29F8A-C5AE-A2F7-DD48-0CE3D8C710D1",
      "type": "building",
      "default_mesh_id": null
    },
    "F16B3374-B04F-2CC3-8D0D-914FD0156EB0": {
      "canonical": "48F29F8A-C5AE-A2F7-DD48-0CE3D8C710D1",
      "type": "building",
      "default_mesh_id": null
    },
    "802BCB77-5AED-C7AE-A467-158217589918": {
      "canonical": "48F29F8A-C5AE-A2F7-DD48-0CE3D8C710D1",
      "type": "building",
      "default_mesh_id": null
    },
    "8EE3ED57-A5B6-7799-6C4D-E5F1596A32AF": {
      "canonical": "48F29F8A-C5AE-A2F7-DD48-0CE3D8C710D1",
      "type": "building",
      "default_mesh_id": null
    },
    "BA63F501-C417-22B0-02A6-2CC50D56F37D": {
      "canonical": "5705689C-47EE-A61F-62EC-022D3EDB3487",
      "type": "trap",
      "default_mesh_id": null
    },
    "1A715FBB-8AF7-B793-2939-F6EC268CD26A": {
      "canonical": "5705689C-47EE-A61F-62EC-022D3EDB3487",
      "type": "trap",
      "default_mesh_id": null
    },
    "15A98BAD-5BB3-FD1A-AC44-909C0577B6E0": {
      "canonical": "5705689C-47EE-A61F-62EC-022D3EDB3487",
      "type": "trap",
      "default_mesh_id": null
    },
    "D1ECF69D-A6F0-606E-1C87-DE30165F2877": {
      "canonical": "755BC755-F388-1ED7-1011-D7B9402182AF",
      "type": "building",
      "default_mesh_id": null
    },
    "81864B53-FFC7-57EC-B5C0-9A7EC53F2385": {
      "canonical": "755BC755-F388-1ED7-1011-D7B9402182AF",
      "type": "building",
      "default_mesh_id": null
    },
    "F82DEB60-821E-1361-CC83-36C4F661F3AB": {
      "canonical": "755BC755-F388-1ED7-1011-D7B9402182AF",
      "type": "building",
      "default_mesh_id": null
    },
    "1C854756-7E6D-22C1-29DC-9346F85E8CB2": {
      "canonical": "755BC755-F388-1ED7-1011-D7B9402182AF",
      "type": "building",
      "default_mesh_id": null
    },
    "726DE252-023F-78C9-EFC8-D6D7D5669254": {
      "canonical": "755BC755-F388-1ED7-1011-D7B9402182AF",
      "type": "building",
      "default_mesh_id": null
    },
    "8DF9C552-C838-B787-89EF-350CE85102BB": {
      "canonical": "755BC755-F388-1ED7-1011-D7B9402182AF",
      "type": "building",
      "default_mesh_id": null
    },
    "A4FE2263-D06C-4898-47F0-973D5692BFEC": {
      "canonical": "755BC755-F388-1ED7-1011-D7B9402182AF",
      "type": "building",
      "default_mesh_id": null
    },
    "4DD35644-5251-500F-9180-7706CDC11759": {
      "canonical": "D78C45B5-E40D-48B1-50DA-C7B82C6D577B",
      "type": "building",
      "default_mesh_id": null
    },
    "53BF9A95-A92A-9E6E-981A-2CBC5BFB10AA": {
      "canonical": "D78C45B5-E40D-48B1-50DA-C7B82C6D577B",
      "type": "building",
      "default_mesh_id": null
    },
    "A10BAE8E-DCAC-B9D5-1AF6-797BCBAC964A": {
      "canonical": "D78C45B5-E40D-48B1-50DA-C7B82C6D577B",
      "type": "building",
      "default_mesh_id": null
    },
    "3402D212-E0F3-B792-0374-4561EDD14465": {
      "canonical": "D78C45B5-E40D-48B1-50DA-C7B82C6D577B",
      "type": "building",
      "default_mesh_id": null
    },
    "1F304499-9E77-4992-566D-CFDDE8B86362": {
      "canonical": "D78C45B5-E40D-48B1-50DA-C7B82C6D577B",
      "type": "building",
      "default_mesh_id": null
    },
    "4D07F41D-3B01-F30C-E7EA-B52D70D72FEA": {
      "canonical": "D78C45B5-E40D-48B1-50DA-C7B82C6D577B",
      "type": "building",
      "default_mesh_id": null
    },
    "AEAB5B8E-8E66-300C-BB46-E0C8AC927A40": {
      "canonical": "D78C45B5-E40D-48B1-50DA-C7B82C6D577B",
      "type": "building",
      "default_mesh_id": null
    },
    "C511B4DE-6331-C982-213B-4BA7D5701D07": {
      "canonical": "58519F8E-09CA-EE8B-C422-C86964544E5A",
      "type": "building",
      "default_mesh_id": null
    },
    "15A92413-FD07-356A-3005-CA0FD3D62C33": {
      "canonical": "58519F8E-09CA-EE8B-C422-C86964544E5A",
      "type": "building",
      "default_mesh_id": null
    },
    "92823F0E-FC64-942E-920B-BBB0090225A7": {
      "canonical": "58519F8E-09CA-EE8B-C422-C86964544E5A",
      "type": "building",
      "default_mesh_id": null
    },
    "3478B6B4-4C71-CCE0-DE0A-016950F3F28A": {
      "canonical": "58519F8E-09CA-EE8B-C422-C86964544E5A",
      "type": "building",
      "default_mesh_id": null
    },
    "B7865803-8BA2-7480-E6A8-00F40B66F303": {
      "canonical": "58519F8E-09CA-EE8B-C422-C86964544E5A",
      "type": "building",
      "default_mesh_id": null
    },
    "B12368DD-26C3-4B03-3148-836666986201": {
      "canonical": "58519F8E-09CA-EE8B-C422-C86964544E5A",
      "type": "building",
      "default_mesh_id": null
    },
    "16E58AC4-3D5E-C139-F6F5-7527F4A554D0": {
      "canonical": "58519F8E-09CA-EE8B-C422-C86964544E5A",
      "type": "building",
      "default_mesh_id": null
    },
    "5361D7CA-96AE-FDE4-AD9D-56949F5A155F": {
      "canonical": "CA5532B1-ED97-C26F-5635-FE09A0B458A8",
      "type": "building",
      "default_mesh_id": null
    },
    "3DE7F95F-389D-72CC-C98D-E156C2C3478C": {
      "canonical": "CA5532B1-ED97-C26F-5635-FE09A0B458A8",
      "type": "building",
      "default_mesh_id": null
    },
    "51215207-1427-F36A-FB60-48DAE88B928F": {
      "canonical": "CA5532B1-ED97-C26F-5635-FE09A0B458A8",
      "type": "building",
      "default_mesh_id": null
    },
    "E34BFB83-A985-E733-6EBA-3ECEBAD6646C": {
      "canonical": "CA5532B1-ED97-C26F-5635-FE09A0B458A8",
      "type": "building",
      "default_mesh_id": null
    },
    "92E8917F-BEA9-0F73-AC8C-1A74379794D1": {
      "canonical": "CA5532B1-ED97-C26F-5635-FE09A0B458A8",
      "type": "building",
      "default_mesh_id": null
    },
    "9BC2D828-CC13-BC61-41D6-09D8AF43D5C9": {
      "canonical": "CA5532B1-ED97-C26F-5635-FE09A0B458A8",
      "type": "building",
      "default_mesh_id": null
    },
    "E96BC472-35F9-B309-BFF5-333A47600B2A": {
      "canonical": "CA5532B1-ED97-C26F-5635-FE09A0B458A8",
      "type": "building",
      "default_mesh_id": null
    },
    "801910F6-98C6-1E24-7DC4-203873B869C9": {
      "canonical": "B8FA4F2E-C6A6-6723-542A-5EDB4A7A5CFB",
      "type": "plant",
      "default_mesh_id": "93ACB422-6311-4350-C5B7-FA36CE51EE4D"
    },
    "FCC303BF-8B82-C1BE-B86B-B169B39A32F6": {
      "canonical": "D8F00045-4CCA-5081-D4B1-1834E8EC0036",
      "type": "furniture",
      "default_mesh_id": "A940CF75-2391-B5BC-4BFB-CA1C13867004"
    },
    "8C191BA5-211F-2EDC-82E1-643723A64F63": {
      "canonical": "223B4D36-08BF-0AC8-928A-954B7D7526BD",
      "type": "building",
      "default_mesh_id": null
    },
    "61A768A2-681F-4591-202C-EE5BB5A765E1": {
      "canonical": "223B4D36-08BF-0AC8-928A-954B7D7526BD",
      "type": "building",
      "default_mesh_id": null
    },
    "12904863-C2A8-D4F7-5E94-9780F450EDA7": {
      "canonical": "223B4D36-08BF-0AC8-928A-954B7D7526BD",
      "type": "building",
      "default_mesh_id": null
    },
    "F4911607-2C7A-8D70-428E-EE181AB9DDE7": {
      "canonical": "223B4D36-08BF-0AC8-928A-954B7D7526BD",
      "type": "building",
      "default_mesh_id": null
    },
    "3E9B62CA-5E7F-F812-3125-0165A934D24E": {
      "canonical": "223B4D36-08BF-0AC8-928A-954B7D7526BD",
      "type": "building",
      "default_mesh_id": null
    },
    "A942E106-31C5-6FDF-2701-07F60B4B31E2": {
      "canonical": "223B4D36-08BF-0AC8-928A-954B7D7526BD",
      "type": "building",
      "default_mesh_id": null
    },
    "CB0ADFFF-89FB-38C7-A7FE-E559B2185A56": {
      "canonical": "223B4D36-08BF-0AC8-928A-954B7D7526BD",
      "type": "building",
      "default_mesh_id": null
    },
    "95C0A559-CD82-04E0-3303-88F07A42F54C": {
      "canonical": "1CA6051C-2E8C-0550-1E07-5986DC2B5A1D",
      "type": "building",
      "default_mesh_id": null
    },
    "1D2BE8B8-381D-A2C4-9A29-337B4160E135": {
      "canonical": "1CA6051C-2E8C-0550-1E07-5986DC2B5A1D",
      "type": "building",
      "default_mesh_id": null
    },
    "2A84C1E9-2972-7115-E168-32B497DE7803": {
      "canonical": "1CA6051C-2E8C-0550-1E07-5986DC2B5A1D",
      "type": "building",
      "default_mesh_id": null
    },
    "DB5CE109-6B78-45E6-8633-6EC16C2D8E16": {
      "canonical": "1CA6051C-2E8C-0550-1E07-5986DC2B5A1D",
      "type": "building",
      "default_mesh_id": null
    },
    "482919AA-964F-6AB8-0DC4-28BEB134D1C9": {
      "canonical": "1CA6051C-2E8C-0550-1E07-5986DC2B5A1D",
      "type": "building",
      "default_mesh_id": null
    },
    "7630EC3C-7524-EE69-75EB-1FCF68C02B78": {
      "canonical": "1CA6051C-2E8C-0550-1E07-5986DC2B5A1D",
      "type": "building",
      "default_mesh_id": null
    },
    "1B58C5B5-F695-61EF-59E7-817D59EFE274": {
      "canonical": "1CA6051C-2E8C-0550-1E07-5986DC2B5A1D",
      "type": "building",
      "default_mesh_id": null
    },
    "247BEBAA-1D1A-28D9-8CB0-315AE40A0D1D": {
      "canonical": "41C954DF-B8A3-C987-5CC7-AD717C3F2366",
      "type": "building",
      "default_mesh_id": null
    },
    "32A90B5E-FD4A-11C2-CD30-1580522B9FD3": {
      "canonical": "41C954DF-B8A3-C987-5CC7-AD717C3F2366",
      "type": "building",
      "default_mesh_id": null
    },
    "441525E5-9E22-F756-1383-67908C9F0067": {
      "canonical": "41C954DF-B8A3-C987-5CC7-AD717C3F2366",
      "type": "building",
      "default_mesh_id": null
    },
    "DC08E743-42F3-60F7-00CF-CB9C29A3B405": {
      "canonical": "41C954DF-B8A3-C987-5CC7-AD717C3F2366",
      "type": "building",
      "default_mesh_id": null
    },
    "7F02F428-03A7-3C9A-8519-20A60D7A3E4C": {
      "canonical": "41C954DF-B8A3-C987-5CC7-AD717C3F2366",
      "type": "building",
      "default_mesh_id": null
    },
    "909E0164-74D3-0C80-CB7A-01F1BEDF58CE": {
      "canonical": "41C954DF-B8A3-C987-5CC7-AD717C3F2366",
      "type": "building",
      "default_mesh_id": null
    },
    "F83FD3DA-4035-B14B-75CE-BE11BCFAA688": {
      "canonical": "41C954DF-B8A3-C987-5CC7-AD717C3F2366",
      "type": "building",
      "default_mesh_id": null
    },
    "78502450-D8FC-3FD6-16BD-68DA936713D8": {
      "canonical": "117E3E2B-249D-3871-C1DA-2FF43DFC7B1E",
      "type": "building",
      "default_mesh_id": null
    },
    "3A7C33FB-C12F-BBAA-48D5-2623EC4B397C": {
      "canonical": "117E3E2B-249D-3871-C1DA-2FF43DFC7B1E",
      "type": "building",
      "default_mesh_id": null
    },
    "2D44C636-C394-8D80-B2CF-93EA903D2597": {
      "canonical": "117E3E2B-249D-3871-C1DA-2FF43DFC7B1E",
      "type": "building",
      "default_mesh_id": null
    },
    "9DCD9AF4-3EEB-78BE-EE69-EA9E52449E54": {
      "canonical": "117E3E2B-249D-3871-C1DA-2FF43DFC7B1E",
      "type": "building",
      "default_mesh_id": null
    },
    "399AA853-C901-4D9D-9280-7480013CD8AA": {
      "canonical": "117E3E2B-249D-3871-C1DA-2FF43DFC7B1E",
      "type": "building",
      "default_mesh_id": null
    },
    "5BBAD0BB-CE6D-BF48-E4D0-8DD3F9C4476D": {
      "canonical": "117E3E2B-249D-3871-C1DA-2FF43DFC7B1E",
      "type": "building",
      "default_mesh_id": null
    },
    "76840879-C920-C0ED-EE35-698B3F1C2775": {
      "canonical": "117E3E2B-249D-3871-C1DA-2FF43DFC7B1E",
      "type": "building",
      "default_mesh_id": null
    },
    "98E4DF2C-9B2C-1EC7-470B-978B90EAE8ED": {
      "canonical": "86948DBF-D38B-F6AD-F655-3FBB4E20FA7C",
      "type": "building",
      "default_mesh_id": null
    },
    "C5259905-D228-9D7C-9AE7-57B1D530E27B": {
      "canonical": "86948DBF-D38B-F6AD-F655-3FBB4E20FA7C",
      "type": "building",
      "default_mesh_id": null
    },
    "D2F36E10-D4A5-6B3D-1138-418314159957": {
      "canonical": "86948DBF-D38B-F6AD-F655-3FBB4E20FA7C",
      "type": "building",
      "default_mesh_id": null
    },
    "124A6F61-6FDB-F419-97D3-E0045C06D8A8": {
      "canonical": "86948DBF-D38B-F6AD-F655-3FBB4E20FA7C",
      "type": "building",
      "default_mesh_id": null
    },
    "057B51C4-080E-88DC-42EE-67301384BFA8": {
      "canonical": "86948DBF-D38B-F6AD-F655-3FBB4E20FA7C",
      "type": "building",
      "default_mesh_id": null
    },
    "7841EF8D-C018-F096-6255-D9D363CEB11C": {
      "canonical": "86948DBF-D38B-F6AD-F655-3FBB4E20FA7C",
      "type": "building",
      "default_mesh_id": null
    },
    "E5EBCB30-4885-4DD9-C26F-E87D2CE30A8E": {
      "canonical": "86948DBF-D38B-F6AD-F655-3FBB4E20FA7C",
      "type": "building",
      "default_mesh_id": null
    },
    "696A76FC-95C6-7512-97B7-FA19C85D3752": {
      "canonical": "E633EDFE-290E-F92F-9E08-A2F3F49002E6",
      "type": "building",
      "default_mesh_id": null
    },
    "CFCCD4EF-6F5E-08A8-D2FB-6FA49C33CC71": {
      "canonical": "E633EDFE-290E-F92F-9E08-A2F3F49002E6",
      "type": "building",
      "default_mesh_id": null
    },
    "B0CB3C07-ECBE-B241-FC3F-DE5D73A21E87": {
      "canonical": "E633EDFE-290E-F92F-9E08-A2F3F49002E6",
      "type": "building",
      "default_mesh_id": null
    },
    "82993C05-7E6D-EC09-9C0B-79E637F049BE": {
      "canonical": "E633EDFE-290E-F92F-9E08-A2F3F49002E6",
      "type": "building",
      "default_mesh_id": null
    },
    "A8EA3E5F-D373-325D-4EA7-6C1D2BFAB43B": {
      "canonical": "E633EDFE-290E-F92F-9E08-A2F3F49002E6",
      "type": "building",
      "default_mesh_id": null
    },
    "D3D5BCCE-5747-02CA-8763-CA3EB2D81BB1": {
      "canonical": "E633EDFE-290E-F92F-9E08-A2F3F49002E6",
      "type": "building",
      "default_mesh_id": null
    },
    "3E64B41C-4B05-F6C1-30A7-E75D4853102A": {
      "canonical": "E633EDFE-290E-F92F-9E08-A2F3F49002E6",
      "type": "building",
      "default_mesh_id": null
    },
    "5B71F99F-BF3C-0899-F996-FF3159799674": {
      "canonical": "2921DF58-113F-EBB1-F006-C615B4C00C14",
      "type": "equipment",
      "default_mesh_id": null
    },
    "E793147B-448F-7D17-F4D7-77143D644FA8": {
      "canonical": "2921DF58-113F-EBB1-F006-C615B4C00C14",
      "type": "equipment",
      "default_mesh_id": null
    },
    "65359AC4-4C0E-9E9E-BA26-3EAC35F2DF08": {
      "canonical": "2921DF58-113F-EBB1-F006-C615B4C00C14",
      "type": "equipment",
      "default_mesh_id": null
    },
    "16487FF4-EDEB-406B-27B7-8FDBCEB37271": {
      "canonical": "DC58BA39-71D4-5FD8-2D1B-20964653664D",
      "type": "equipment",
      "default_mesh_id": null
    },
    "7DB510FD-7507-BEA9-2FE2-01093C36A8A6": {
      "canonical": "DC58BA39-71D4-5FD8-2D1B-20964653664D",
      "type": "equipment",
      "default_mesh_id": null
    },
    "3B357C98-EA0F-90F8-0047-9E9788EF5C33": {
      "canonical": "DC58BA39-71D4-5FD8-2D1B-20964653664D",
      "type": "equipment",
      "default_mesh_id": null
    },
    "F76F6637-676F-322C-EE00-DDDC07911BFC": {
      "canonical": "DC58BA39-71D4-5FD8-2D1B-20964653664D",
      "type": "equipment",
      "default_mesh_id": null
    },
    "3C0EE8A5-D8B6-11D3-0F59-1A924C590A96": {
      "canonical": "F4C2D533-0F13-A586-0834-1B06BB5C8F6B",
      "type": "equipment",
      "default_mesh_id": null
    },
    "3608398B-EC73-20C5-9F13-850B9173910F": {
      "canonical": "F4C2D533-0F13-A586-0834-1B06BB5C8F6B",
      "type": "equipment",
      "default_mesh_id": null
    },
    "43409331-A533-994B-277D-DD6644CC940C": {
      "canonical": "F4C2D533-0F13-A586-0834-1B06BB5C8F6B",
      "type": "equipment",
      "default_mesh_id": null
    },
    "CB6B2C8F-9682-E4A3-C9BC-F40B866B9CDF": {
      "canonical": "F4C2D533-0F13-A586-0834-1B06BB5C8F6B",
      "type": "equipment",
      "default_mesh_id": null
    },
    "D00C9486-180E-9345-29BC-89F1B1BD0852": {
      "canonical": "B88ED616-9024-E72E-0854-C51B66F9EAEF",
      "type": "reagent",
      "default_mesh_id": null
    },
    "3F32698D-6CFE-338A-E6A4-56F67693FCBB": {
      "canonical": "8B5ADC58-823F-4C79-A64E-407D7C8611A4",
      "type": "equipment",
      "default_mesh_id": null
    },
    "14F3A370-C43B-49D0-B3E4-8D7BBC91035B": {
      "canonical": "E3864CB3-39CA-5E7F-A3B5-F8785FEFC598",
      "type": "furniture",
      "default_mesh_id": null
    },
    "5E4733E8-7B1E-1079-F835-8D852AC18024": {
      "canonical": "BDD74394-4C8F-8A28-1263-0F44F184D133",
      "type": "artwork",
      "default_mesh_id": null
    }
  }
}
